import React from 'react';

interface Props {}

interface State {}

class PaidInvoices extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }
    render() {
        return <div>Paid Invoices</div>;
    }
}

export default PaidInvoices;
